export interface userSocialMediaLink {
  UserSocialMediaId?: string;
  SocialMediaPlatformId: string;
  UserId?: string;
  SocialMediaLink: string;
}

export function newUserSocialMediaLink(): userSocialMediaLink {
  return {
    UserSocialMediaId: "",
    SocialMediaPlatformId: "",
    UserId: "",
    SocialMediaLink: "",
  };
}
export function newUserSocialMediaLinkArray(): userSocialMediaLink[] {
  return [];
}
